export enum RouterBehavior {
  SMOOTH = 'smooth',
  AUTO = 'auto',
}
